<template src="./unitListVue.template.html"></template>
<script>
  export default {
    name: "unitListComponent",
    props: [],
    data() {
      return {
        entitlements: {},
        AddButton:true,
        headerColumnList: [],
        propertyList: [],
        statusList: [],
        unitList: [],
        propertyId: -99,
        statusId: 1,
        checkedUnits: [],
        toggleFilterPanel: false,
        isGreyOut: false,
        viewSaveObject: {
          properties: [],
        },
        selectedFilterColumn: null,
        loading: true,
        headerColumnList: {
          PROPERTYNAME: { Label: "PROPERTY NAME", IsChecked: true, ColumnName: "Property", isSortLoading: false, isAscOrDesc: null },
          UNITNAME: {
            Label: "UNIT NAME", IsChecked: true, ColumnName: "UnitName", isSortLoading: false, isAscOrDesc: null
          },
          NICKNAME: {
            Label: "UNIT NICKNAME", IsChecked: true, ColumnName: "NickName", isSortLoading: false, isAscOrDesc: null
          },
          UnitClass: { Label: "UNIT CLASS", IsChecked: true, ColumnName: "UnitClassName", isSortLoading: false, isAscOrDesc: null },
          UnitType: { Label: "UNIT TYPE", IsChecked: true, ColumnName: "UnitTypeName", isSortLoading: false, isAscOrDesc: null },
          // UNITCLASS: { Label: "UNIT CLASS", IsChecked: true, ColumnName: "UNIT CLASS" },
          // EndDate: { Label: "", IsChecked: true, ColumnName: "EndDate" },
          MAXOCCUPANCY: { Label: "MAX OCCUPANCY", IsChecked: true, ColumnName: "MaxPersons", columnClass: "numeriColumn", isSortLoading: false, isAscOrDesc: null },
          UNITRANK: { Label: "UNIT RANK", IsChecked: true, ColumnName: "UnitRank", columnClass: "numeriColumn", isSortLoading: false, isAscOrDesc: null },
          // SourceName: { Label: "Source Name", IsChecked: true,  ColumnName: "SourceName"},
          STATUS: { Label: "STATUS", IsChecked: true, ColumnName: "StatusName", columnClass: "numeriColumn", isSortLoading: false, isAscOrDesc: null },

        },
        // viewSaveObject:{
        //   sortColumn: null,
        //   sortOrder: null,
        // },
        filterObj: {
          Properties: [],
          SortBy: null,
          SortOrder: null,
          SearchText: null,
          Columns: []
        },
        filterColumnList: {
          UnitName: { Label: "Unit Name", ColumnName: "UnitName" },
          UnitClass: { Label: "UnitClass", ColumnName: "UnitClass" },
          MaxOccupency: { Label: "MaxOccupency", ColumnName: "MaxOccupency" },
          UnitRank: { Label: "UnitRank", ColumnName: "UnitRank" },

        },
        filterSearchPropertyText: null,
        IsHostModeObj: null,

      };
    },

    methods: {
      GetUserEntitlementsAndDefaultProperty() {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "GetUserEntitlementsAndDefaultProperty",
          params: {
            ModuleAction: "GetUserEntitlementsAndDefaultProperty"
          },
          callback: function (err, response) {
            if (err) {
              return;
            }
            if (response) {
              console.log("response in GetUserEntitlementsAndDefaultProperty", response);
              // vm.UserProperties = response.properties;
              vm.entitlements = response.userEntitlementList;
              vm.enableAddButton();

              // vm.DefaultProperty = response.defaultPropertyId;
            }
          }
        });
      },    
      enableAddButton() {
        let vm = this;
        if (vm.entitlements && vm.entitlements.fncUnitNew.isAssigned === -1) {
          vm.AddButton = false;

        }
        else {
          vm.AddButton = true;
        }
      },

      applyFilter() {
        let vm = this;
        vm.filterObj.SearchText = null;
        vm.toggleFilterPanel = false;
        //vm.$store.state.bus.$emit('clearSearchText');        
        vm.viewSaveObject.propertyId = vm.filterObj.PropertyId;
        // vm.viewSaveObject.UnitClassId = vm.filterObj.UnitClassId;
        // vm.viewSaveObject.resSourceId = vm.filterObj.resSourceId;

        // vm.viewSaveObject.tags.splice(0, vm.viewSaveObject.tags.length, ...vm.filterObj.TagsList);
        vm.viewSaveObject.properties.splice(0, vm.viewSaveObject.properties.length, ...vm.filterObj.Properties);
        // vm.viewSaveObject.UnitClasses.splice(0, vm.viewSaveObject.UnitClasses.length, ...vm.filterObj.UnitClasses);
        // vm.viewSaveObject.sources.splice(0, vm.viewSaveObject.sources.length, ...vm.filterObj.Sources);
        // vm.viewSaveObject.columns.splice(0, vm.viewSaveObject.columns.length, ...vm.filterObj.Columns);

        // vm.viewAttrsChanged = true;
        // vm.getReservationsList();
      },
      deleteSelectedPropertyFromFilter(index, propObj) {
        this.removePropertyFromFilter(propObj);
        this.viewSaveObject.properties.splice(index, 1);
      },
      addPropertyToFilter(propertyObj) {
        this.filterObj.Properties.push(propertyObj);
        this.filterSearchPropertyText = null;
      },
      removePropertyFromFilter(propertyObj) {
        if (propertyObj) {
          let index = this.filterObj.Properties.findIndex((currProperty) => {
            return currProperty.PropertyId === propertyObj.PropertyId;
          })
          if (index > -1) {
            this.filterObj.Properties.splice(index, 1);
          }
        }
      },
      showFilterByType(property) {
        if (this.selectedFilterColumn == property)
          this.selectedFilterColumn = null;
        else
          this.selectedFilterColumn = property;

      },
      closeFilter: function () {
        this.toggleFilterPanel = false
      },
      addColumnToFilters(colObj) {
        let index = this.filterObj.Columns.findIndex((currCol) => {
          return currCol.colunmName === colObj.ColumnName;
        })
        if (index === -1) {
          this.filterObj.Columns.push(JSON.parse(JSON.stringify({ colunmName: colObj.ColumnName, label: colObj.Label, text: null, arrText: [] })));
        }
      },
      addSearcTextToColumn(filterCol, event) {
        if (event.key == "Enter") {
          filterCol.arrText.push(filterCol.text);
          filterCol.text = null;
        }
      },
      removeSearchTextFromColumn(selectedText, filterCol) {
        if (filterCol.arrText.indexOf(selectedText) > -1) {
          filterCol.arrText.splice(filterCol.arrText.indexOf(selectedText), 1)
        }
      },

      ascSort(sortBy, sortOrder) {
        let vm = this;


        vm.filterObj.SortBy = sortBy;
        vm.filterObj.SortOrder = sortOrder;
        for (var i in vm.headerColumnList) {
          if (vm.headerColumnList[i]) {
            var obj = vm.headerColumnList[i];
            console.log("obj", obj);
            // for (var j in obj.sortLabels) {
            if (sortBy.toString() === obj.ColumnName) {
              console.log("obj.ColumnName", obj.ColumnName);
              vm.headerColumnList[i].isSortLoading = true;
              vm.headerColumnList[i].isAscOrDesc = sortOrder.toString();
              //   }
              // }
            }
          }
        }

        vm.getUnitDetailList();


        //vm.getReservationsList(vm.propertyId, vm.UnitClassId, vm.ViewListId, SortBy, SortOrder, vm.sourceID);
      },
      switchView() {
        if (this.listType === "list") this.listType = "card";
        else this.listType = "list";
      },
      unitDetail: function (propertyId) {
        //console.log("unitDetail " + propertyId);
        // window.location.href = this.$store.state.uiPageName + "#unitDetail/-1";
        // this.$router.push("/unitDetail/-1"+"/"+propertyId);
        this.$store.commit('setpullRUSpecProp', null);
        this.$router.push("/unitDetail/" + -99 + "/" + propertyId);

      },

      exportToExcel: function () {
      },
      deleteUnitDetail: function () {

      },
      getPropertyMetaData: function () {
        let vm = this;
        // this.$store.dispatch("dataRequestHandler", {
        //   key: "GetPropertyMetaData",
        //   params: {
        //     ModuleAction: "GetPropertyMetaData",
        //     PropertyId: scope.propertyId
        //   },
        //   callback: function (err, response) {
        //     if (response) {
        //       console.log("response in unit list dropdown", response);
        //       scope.propertyList = response.recordsets[1];
        //       scope.statusList = response.recordsets[3];
        //     } else {
        //       console.log(err);
        //     }
        //   }
        // });
        vm.$store.dispatch("dataRequestHandler", {
          key: "GetPropertiesBySearchText",
          params: {},
          callback: function (err, response) {
            if (err) {
              return;
            }
            if (response) {
              console.log("GetPropertiesBySearchText==>", response);
              vm.propertyList.splice(0, vm.propertyList.length, ...response.propertyList);
              vm.statusList.splice(0, vm.statusList.length, ...response.statusList);

            }
          }
        });


      },
      getUnitDetailList: function (propertyId, statusId, searchText) {
        let scope = this;
        //scope.$store.state.bus.$emit('clearSearchText');

        //console.log("In get unit detail list" + propertyId + statusId);
        this.$store.dispatch("dataRequestHandler", {
          key: "GetUnitList",
          params: {
            ModuleAction: "GetUnitList",
            PropertyId: propertyId,
            StatusId: statusId,
            SearchText: searchText ? searchText : null,
            filterObj: scope.filterObj

          },
          callback: function (err, response) {
            console.log("responseresponse==>", response);
            if (response) {

              scope.loading = false;
              scope.unitList = response.recordsets[1];
              scope.IsHostModeObj = response.recordsets[2]
              console.log("scope.unitList=>", scope.unitList);
              // if (scope.unitList.length > 0) {
              //   scope.$store.dispatch("toastr", {
              //     type: "success",
              //     header: "Success!",
              //     message: "Unit List Rendered"
              //   });
              // }
              scope.loading = false;
              for (var i in scope.headerColumnList) {

                if (scope.headerColumnList[i]) {
                  var obj = scope.headerColumnList[i];
                  console.log("obj", obj)

                  if (scope.filterObj.SortBy === obj.ColumnName.toString()) {
                    console.log("obj.ColumnName", obj.ColumnName);
                    scope.headerColumnList[i].isSortLoading = false;
                    scope.isGreyOut = false;
                    if (scope.isGreyOut === false && scope.headerColumnList[i].isSortLoading === false) {
                      $('ul.dropdown-menu').removeClass('show').addClass('hide');
                    }
                    // scope.headerColumnList[i].isAscOrDesc = sortOrder.toString();
                  }

                }
              }


            } else {
              console.log(err);
            }
          }
        });
      },
      viewUnitDetailById: function (unitId, propertyId) {
        this.$store.commit('setpullRUSpecProp', null);
        this.$router.push("/unitDetail/" + unitId + "/" + propertyId);
      }
    },

    computed: {
      selectAll: {
        get: function () {
          return this.unitList
            ? this.checkedUnits.length == this.unitList.length
            : false;
        },
        set: function (value) {
          var checkedUnits = [];

          if (value) {
            this.unitList.forEach(function (unitList) {
              checkedUnits.push(unitList.UnitId);
            });
          }

          this.checkedUnits = checkedUnits;
        }
      },
      fncIsUnitSelect() {
        let vm = this;
        if (
          vm.$store.state.userEntitlementList.hasOwnProperty("fncUnitSelect")
        ) {
          // console.log("fncPropertyList =>",vm.$store.state.userEntitlementList);
          let fncUnitSelect =
            vm.$store.state.userEntitlementList.fncUnitSelect;
          // console.log("fncPropertyList", fncPropertyList)
          //return vm.$store.state.userEntitlementList.hasOwnProperty("fncPropertySave") ? vm.$store.state.userEntitlementList.fncPropertySave : null;
          return fncUnitSelect;
        }
        return null;
      },
      fncIsUnitList() {
        let vm = this;
        if (vm.$store.state.userEntitlementList.hasOwnProperty("fncUnitList")) {
          console.log("fncUnitList =>", vm.$store.state.userEntitlementList);
          let fncUnitList = vm.$store.state.userEntitlementList.fncUnitList
          console.log("fncUnitList", fncUnitList)
          return fncUnitList;
        }
        return null;
      },

      fncIsUnitNew() {
        let vm = this;
        if (vm.$store.state.userEntitlementList.hasOwnProperty("fncUnitNew")) {
          console.log("fncUnitNew =>", vm.$store.state.userEntitlementList);
          let fncUnitNew = vm.$store.state.userEntitlementList.fncUnitNew
          console.log("fncUnitNew", fncUnitNew)
          return fncUnitNew;
        }
        return null;
      },

    },

    mounted() {
      let vm = this;
      this.getPropertyMetaData();
      this.getUnitDetailList(-99, 1);
      this.GetUserEntitlementsAndDefaultProperty();
      vm.$store.state.bus.$on('Search-In-Unit-List', function (searchText) {
        console.log(searchText);
        vm.getUnitDetailList(-99, 1, searchText);
      });
      $(this.$el).find("ul.dropdown-menu").click(function (e) {
        e.stopPropagation();
      });
    }
  };
</script>